module.exports = __webpack_public_path__ + "static/cornwallis-8bac8921ed54816b3ea4dd9caa58084f.jpg";